import { Button, Image, message, Rate, Spin } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { memo, useEffect, useMemo, useState } from 'react';
import api from '@/api/customer';
import { defaultInfo } from '@/typings/allType';
import MapCom from '@/components/MapCom';
import publicMethod from '@/utils/publicMethod';
import dayjs from 'dayjs';
import TaskPhotos from '@/components/TaskPhotos';
import TaskVideo from '@/components/TaskVideo';
import ReviewList from '@/components/ReviewList';
import format from '@/utils/format';
import AssignTaskerModal from './tasks/AssignTaskerModal';
import TaskLogModal from './tasks/TaskLogModal';
import CancelTaskModal from './tasks/CancelTaskModal';
const TaskDetails = () => {
    const params = useParams();
    const link = useNavigate();
    const [complete, isComplete] = useState(true);
    const [taskInfo, setTaskInfo] = useState<any>({
        customerId: '',
    });
    const [extraWorkList, setOptionalList] = useState<{ workContent: string }[]>([]);
    const filterWorkList = list => {
        const arr: { workContent: string }[] = [];
        list.forEach(w => {
            arr.push({ workContent: w.workContent });
            if (arr.length === list.length) {
                setOptionalList(arr);
            }
        });
    };
    const [state, setState] = useState<any>({
        ratingInfo: {
            ratingScore: 0,
            totalRatingCount: 0,
        },
        extraWorkList: [] as defaultInfo[],
        timeUntilStart: '-',
    });
    const [loading, setLoading] = useState(true);
    const type = new URLSearchParams(useLocation().search).get('type');
    const getInfo = async data => {
        try {
            const res = await api.getTaskDetail(idType, data.userId, data.taskId);
            if (res.data.taskState !== 'completed' || res.data.taskState !== 'completed') {
                res.data.timeUntilStart = res.data.workStartDate
                    ? window.utils.getTimeUntilStart(res.data.workStartDate, res.data.workStartTime)
                    : '-';
            }
            res.data.extraWorkList &&
                res.data.extraWorkList.extraWorkContentList &&
                filterWorkList(res.data.extraWorkList.extraWorkContentList);
            setState(res.data);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const [idType, setIdType] = useState('');
    useEffect(() => {
        const taskInfo = JSON.parse(window.sessionStorage.getItem('taskInfo') ?? '{}');
        if (taskInfo.userId && taskInfo.taskId && idType) {
            getInfo(taskInfo);
        }
    }, [idType]);
    useEffect(() => {
        if (type) {
            setIdType(window.atob(type));
        }
    }, []);
    const [openVideoModal, setVideoModalOpen] = useState(false);
    const videoOpen = () => {
        setVideoModalOpen(true);
    };
    const videoClose = () => {
        setVideoModalOpen(false);
    };
    const cancelReason = (type: string) => {
        let cancelType = 'Other';
        switch (type) {
            case 'UNEXPECTED_ILLNESS_OR_INJURY':
                cancelType = 'Unexpected Illness or injury';
                break;
            case 'NOT_UNDERSTANDING_THE_TASK':
                cancelType = 'Not understanding the task';
                break;
            case 'GOVERNMENT_SERVICE_DUTIES':
                cancelType = 'Government service duties';
                break;
            case 'UNAVAILABLE_DUE_TO_CALENDAR_CONFLICT':
                cancelType = 'Unavailable due to calendar conflict';
                break;
            case 'TRAVEL_DISRUPTIONS':
                cancelType = 'Travel disruptions';
                break;
            case 'NOT_HAVING_THE_NECESSARY_SKILLS':
                cancelType = 'Not having the necessary skills';
                break;
            default:
                break;
        }
        return cancelType;
    };
    const [currentTask, setCurrentTask] = useState<{
        taskId: string;
        workEndTime: string | null;
        type: '' | 'assign' | 'log' | 'cancel';
    }>({
        taskId: '',
        workEndTime: null,
        type: '',
    });
    return loading ? (
        <div className="data_loading flex-center" style={{ minHeight: 300 }}>
            <Spin />
        </div>
    ) : (
        <div className="page-main task-details">
            <div className="page-title flex-between">
                <div>
                    <img
                        className="back-icon"
                        src={require('@/assets/images/back-icon.png')}
                        alt="back-icon"
                        onClick={() => link(-1)}
                    />
                    Task Details
                    <span className="customer-name">({state.taskTitle})</span>
                </div>
                {state.taskState !== 'canceled' && (
                    <div>
                        {state.taskState !== 'completed' && (
                            <Button
                                danger
                                onClick={() =>
                                    setCurrentTask({
                                        taskId: state.taskId,
                                        workEndTime: null,
                                        type: 'cancel',
                                    })
                                }
                                style={{ height: 36 }}
                            >
                                Cancel Job
                            </Button>
                        )}
                        <Button
                            onClick={() =>
                                setCurrentTask({
                                    taskId: state.taskId,
                                    workEndTime: null,
                                    type: 'log',
                                })
                            }
                            style={{ height: 36, margin: '0 16px', borderColor: '#1A1E1F' }}
                        >
                            Task log
                        </Button>
                        {!state.tasker && (
                            <Button
                                onClick={() =>
                                    setCurrentTask({
                                        taskId: state.taskId,
                                        workEndTime: state.workEndTime,
                                        type: 'assign',
                                    })
                                }
                                style={{ height: 36, borderColor: '#1A1E1F' }}
                            >
                                Assign to a Tasker for review
                            </Button>
                        )}
                    </div>
                )}
            </div>
            {state.taskState !== 'canceled' &&
                (state.taskState === 'completed' ? (
                    <div className="task-status-card" style={{ background: '#fff' }}>
                        <div className="flex-center">
                            <img src={require(`@/assets/images/in-progress.png`)} alt="" />
                            <div>
                                <div className="task-start-time">
                                    {state?.paidToTaskerTime ? 'Payment released successfully' : 'Payment released in'}
                                </div>
                                {!state?.paidToTaskerTime && <div>24-48 hours</div>}
                            </div>
                        </div>
                        <div className="task-amount">
                            $
                            {state.actualRemunerationAmount
                                ? publicMethod.formatPrice(state.actualRemunerationAmount)
                                : '0.00'}
                        </div>
                    </div>
                ) : state.tasker ? (
                    <div className="task-status-card">
                        <div className="flex-center">
                            <img
                                src={require(`@/assets/images/${
                                    publicMethod.formatStartTime(`${state.workStartTime}`)
                                        ? 'clock-icon'
                                        : 'task-active'
                                }.png`)}
                                alt=""
                            />
                            {state.taskState === 'started' ||
                            !publicMethod.formatStartTime(`${state.workStartTime}`) ? (
                                <div className="task-start-time">Task Active</div>
                            ) : (
                                <div>
                                    <div className="task-start-time">
                                        {publicMethod.formatStartTime(`${state.workStartTime}`)}
                                    </div>
                                    <div>Until tasks starts</div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="task-status-card" style={{ height: 88 }}>
                        <div className="flex-center">
                            <FindingTasker task={state} />
                            <div>
                                <div className="task-start-time">Finding the Tasker...</div>
                                <div>Sit tight while we find you the best Tasker for the task</div>
                            </div>
                        </div>
                    </div>
                ))}
            {state.taskState !== 'completed' && state.imageArray ? (
                <TaskPhotos imageArray={state.imageArray} startIndex={3} />
            ) : (
                ''
            )}
            {state.taskState !== 'completed' && state.video ? (
                <TaskVideo
                    videoUrl={state.video}
                    openVideoModal={openVideoModal}
                    onOpen={videoOpen}
                    onClose={videoClose}
                />
            ) : (
                ''
            )}
            {state.taskState === 'canceled' || (idType === 'tasker' && state.taskState === 'received') ? (
                <div className="content-card">
                    <h3>
                        <img src={require('@/assets/images/work-address-icon.png')} alt="report" /> Task Location & pay
                    </h3>
                    <MapCom
                        location={state.workGeoPoint}
                        editTaskId="123"
                        workAddress={state.workAddress}
                        mapWidth={560}
                        mapHeight={186}
                    />
                    {state.workStartDate ? (
                        <div className="cancel-detail-task-time">
                            <div>
                                <div className="font-r12 font-c97">
                                    {dayjs(state.workStartDate).format('ddd DD MMM')}
                                </div>
                                <div className="font-sb14">{dayjs(state.workStartTime).format('hh:mm A')}</div>
                            </div>
                            <div className="font-r14 font-c97">To</div>
                            <div>
                                <div className="font-r12 font-c97">{dayjs(state.workEndDate).format('ddd DD MMM')}</div>
                                <div className="font-sb14">
                                    {dayjs(`${state.workEndDate} ${state.workEndTime}`).format('hh:mm A')}
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className="flex-left task-pay-card">
                        <img className="icon-24" src={require('@/assets/images/work-pay-icon.png')} alt="" />
                        <div>
                            <div>
                                $
                                {state.actualRemunerationAmount
                                    ? publicMethod.formatPrice(state.actualRemunerationAmount)
                                    : '0.00'}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}
            {state.taskState === 'canceled' && (state.tasker || state.customer) ? (
                <div
                    className="flex-between"
                    style={{
                        padding: '14px 12px',
                        borderRadius: 8,
                        width: 600,
                        marginTop: 24,
                        background: '#fff',
                    }}
                >
                    <div className="flex-start" style={{ flex: 1 }}>
                        <img
                            src={state.tasker ? state.tasker.avatarUrl : state.customer.avatarUrl}
                            className="icon-32"
                            alt=""
                            style={{ borderRadius: 16 }}
                        />
                        <span className="font-r14 font-c97" style={{ margin: '0 4px 0 16px' }}>
                            {idType === 'customer' ? 'Done' : 'Posted'} by
                        </span>
                        <span className="font-sb14" style={{ flex: 1 }}>
                            {state.tasker ? state.tasker.fullName : state.customer.fullName}
                        </span>
                    </div>
                    <div className="tasker-rate">
                        <img src={require('@/assets/images/star.png')} alt="" />
                        {Number(
                            state.tasker ? state.tasker.ratingInfo.ratingScore : state.customer.ratingInfo.ratingScore
                        ).toFixed(1)}
                    </div>
                </div>
            ) : (
                ''
            )}
            <div className="content-card task-box">
                <div className="card-title">{state.taskTitle}</div>
                <div className="card-item-label categorie-tag">
                    Categories:
                    <div>{state.taskCategory && state.taskCategory.categoryName}</div>
                </div>
                <div className="card-item-value">
                    {RegExp(/\n/).test(state.taskDescription)
                        ? state.taskDescription.split('\n').map((t, index) => {
                              return (
                                  <div className="font-r14" key={'description' + index}>
                                      {t}
                                  </div>
                              );
                          })
                        : state.taskDescription}
                </div>
                <div className="card-item-label">Qualifications / Licences Required</div>
                <div className="card-item-value">{state.requiresCertificate ? 'Yes' : 'N/A'}</div>

                {state.taskState === 'received' && idType === 'customer' ? (
                    <>
                        <div className="card-item-label">Date</div>
                        <div className="card-item-value">
                            {state.asap && !state.workStartDate
                                ? 'ASAP'
                                : publicMethod.taskTimeFormat(
                                      //   state.workStartDate,
                                      state.workStartTime,
                                      //   state.workEndDate
                                      state.workEndTime
                                  )}
                        </div>
                        <div className="card-item-label">Task Location</div>
                        <div className="card-item-value" style={{ color: '#979797', marginBottom: 8 }}>
                            Actual address won't be shared until we've matched you with a Tasker.
                        </div>
                        <div className="font-r15">{state.workAddress ?? '-'}</div>
                        {state.workGeoPoint ? (
                            <MapCom
                                mapWidth={310}
                                mapHeight={110}
                                location={state.workGeoPoint}
                                editTaskId="123"
                                workAddress={state.workAddress}
                            />
                        ) : (
                            ''
                        )}
                        <div className="card-item-label">Pay</div>
                        <div className="card-item-value">
                            $
                            {state.actualRemunerationAmount
                                ? publicMethod.formatPrice(state.actualRemunerationAmount)
                                : '0.00'}
                        </div>
                    </>
                ) : (
                    ''
                )}
            </div>
            {state.taskState === 'completed' ? (
                <div className="content-card">
                    {state.tasker ? (
                        <div
                            className="flex-between"
                            style={{
                                border: '1px solid #F0F0F0',
                                padding: '14px 12px',
                                borderRadius: 8,
                                marginBottom: 12,
                            }}
                        >
                            <div className="flex-left" style={{ flex: 1 }}>
                                <img
                                    src={state.tasker.avatarUrl}
                                    className="icon-32"
                                    alt=""
                                    style={{ borderRadius: 16 }}
                                />
                                <span
                                    className="font-r14 font-c97"
                                    style={{ margin: '0 4px 0 16px', whiteSpace: 'nowrap' }}
                                >
                                    Carried out by
                                </span>
                                <span className="font-sb14" style={{ flex: 1, marginRight: 4 }}>
                                    {state.tasker.fullName}
                                </span>
                            </div>
                            <div className="tasker-rate">
                                <img className="icon-14" src={require('@/assets/images/star.png')} alt="" />
                                {Number(state.tasker.ratingInfo.ratingScore).toFixed(1)}
                            </div>
                        </div>
                    ) : (
                        <div
                            className="flex-between"
                            style={{
                                border: '1px solid #F0F0F0',
                                padding: '14px 12px',
                                borderRadius: 8,
                                marginBottom: 12,
                            }}
                        >
                            <div className="flex-left" style={{ flex: 1 }}>
                                <img
                                    src={state.customer.avatarUrl}
                                    className="icon-32"
                                    alt=""
                                    style={{ borderRadius: 16 }}
                                />
                                <span
                                    className="font-r14 font-c97"
                                    style={{ margin: '0 4px 0 16px', whiteSpace: 'nowrap' }}
                                >
                                    Posted by
                                </span>
                                <span className="font-sb14" style={{ flex: 1, marginRight: 4 }}>
                                    {state.customer.fullName}
                                </span>
                            </div>
                            <div className="tasker-rate">
                                <img className="icon-14" src={require('@/assets/images/star.png')} alt="" />
                                {Number(state.customer.ratingInfo.ratingScore).toFixed(1)}
                            </div>
                        </div>
                    )}
                    <div className="font-r15" style={{ marginBottom: 12 }}>
                        <img
                            className="icon-24"
                            src={require('@/assets/images/calendar-t.png')}
                            alt=""
                            style={{ marginRight: 12 }}
                        />
                        {state.asap && !state.workStartTime
                            ? 'ASAP'
                            : publicMethod.taskTimeFormat(
                                  //   state.workStartDate,
                                  state.workStartTime,
                                  //   state.workEndDate,
                                  state.workEndTime
                              )}
                    </div>
                    <div className="font-r15 flex-left" style={{ marginBottom: 12 }}>
                        <img
                            className="icon-24"
                            src={require('@/assets/images/completed-task.png')}
                            alt=""
                            style={{ marginRight: 12 }}
                        />
                        {format.customFormat(state.taskerClickCompletionTime, 'HH:mm A, D MMM YYYY')}
                    </div>
                    <div className="font-r15 flex-left" style={{ marginBottom: 12 }}>
                        <img
                            className="icon-24"
                            src={require('@/assets/images/address.png')}
                            alt=""
                            style={{ marginRight: 12 }}
                        />
                        {state.workAddress}
                    </div>
                    <div className="font-r15">
                        <img
                            className="icon-24"
                            src={require('@/assets/images/pay-icon.png')}
                            alt=""
                            style={{ marginRight: 12 }}
                        />
                        ${state.actualRemunerationAmount}
                    </div>
                </div>
            ) : (
                ''
            )}
            {extraWorkList.length ? (
                <>
                    <div className="card-title-large">
                        <img src={require('@/assets/images/Huge-icon.png')} alt="Huge-icon" />
                        Optional Task Checklist
                    </div>

                    <div className="content-card tasks">
                        {extraWorkList.map((item, i) => {
                            return (
                                <div className="task-item" key={'workContent' + i}>
                                    <img src={require('@/assets/images/task-c.png')} alt="task-c" />
                                    {i + 1}. {item.workContent ?? '-'}
                                </div>
                            );
                        })}
                        {state.taskState === 'completed' ? (
                            <>
                                <div className="card-item-label">Add Photos</div>
                                <div className="photos-box">
                                    {state.extraWorkList.workPhotoList &&
                                        state.extraWorkList.workPhotoList.map(i => {
                                            return <Image key={i + 'li'} src={i} />;
                                        })}
                                </div>
                                <div className="card-item-label">Add Notes</div>
                                <div className="message-box">{state.extraWorkList.workNote}</div>
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </>
            ) : (
                ''
            )}
            {state.taskState === 'completed' ? (
                <>
                    {state.reportList && state.reportList.length
                        ? state.reportList.map(r => {
                              return (
                                  <div className="content-card">
                                      <h3>
                                          <img src={require('@/assets/images/report.png')} alt="report" /> Report
                                      </h3>
                                      <div className="card-item-label">Photos</div>
                                      <div className="photos-box" style={{ marginBottom: r.feedbackContent ? 24 : 0 }}>
                                          {r.feedbackImg.length &&
                                              r.feedbackImg.map(i => {
                                                  return <Image key={i + 're-img'} src={i} />;
                                              })}
                                      </div>
                                      {r.feedbackContent ? (
                                          <>
                                              <div className="card-item-label">Messages</div>
                                              <div className="message-box">{r.feedbackContent}</div>
                                          </>
                                      ) : (
                                          ''
                                      )}
                                  </div>
                              );
                          })
                        : ''}
                    {state.raterRatingInfo ? (
                        <>
                            <div className="card-title-large">
                                <img src={require('@/assets/images/reviews.png')} alt="reviews" />
                                Your review
                            </div>
                            {/* Shared with the tasker profile's Reviews tab, so photos and the
                                task/job reference render the same way everywhere. */}
                            <ReviewList tableData={[state.raterRatingInfo]} />
                        </>
                    ) : (
                        ''
                    )}
                    {state.taskState === 'completed' && state.imageArray ? (
                        <TaskPhotos imageArray={state.imageArray} startIndex={3} />
                    ) : (
                        ''
                    )}
                    {state.taskState === 'completed' && state.video ? (
                        <TaskVideo
                            videoUrl={state.video}
                            openVideoModal={openVideoModal}
                            onOpen={videoOpen}
                            onClose={videoClose}
                        />
                    ) : (
                        ''
                    )}
                    {state.argumentList && state.argumentList.length
                        ? state.argumentList.map(a => {
                              return (
                                  <div className="content-card">
                                      <h3>
                                          <img src={require('@/assets/images/feedback.png')} alt="feedback" /> Argument
                                      </h3>
                                      <div className="card-item-label">Photos</div>
                                      <div className="photos-box">
                                          {a.feedbackImg.length &&
                                              a.feedbackImg.map(i => {
                                                  return <Image key={i + 'ar-img'} src={i} />;
                                              })}
                                      </div>
                                      {a.feedbackContent ? (
                                          <>
                                              <div className="card-item-label">Messages</div>
                                              <div className="message-box">{a.feedbackContent}</div>
                                          </>
                                      ) : (
                                          ''
                                      )}
                                  </div>
                              );
                          })
                        : ''}
                </>
            ) : (
                ''
            )}
            {state.taskState === 'canceled' && state.taskerCancelTask ? (
                <>
                    <div className="card-title-large">
                        <img src={require('@/assets/images/Huge-icon.png')} alt="Huge-icon" />
                        Explanation Box
                    </div>
                    <div className="content-card">
                        <div className="cancelled-card-label">
                            {cancelReason(state.taskerCancelTask.taskerCancelTaskReason)}
                        </div>
                        <div className="cancelled-content">
                            <div className="cancelled-content-label">More details</div>
                            <div className="cancelled-content-text">{state.taskerCancelTask.message}</div>
                        </div>
                    </div>
                </>
            ) : (
                ''
            )}
            <AssignTaskerModal
                taskId={currentTask.taskId && currentTask.type === 'assign' ? currentTask.taskId : ''}
                workEndTime={currentTask.workEndTime}
                onCancel={() => setCurrentTask({ taskId: '', workEndTime: null, type: '' })}
            />
            <TaskLogModal
                taskId={currentTask.taskId && currentTask.type === 'log' ? currentTask.taskId : ''}
                onCancel={() => setCurrentTask({ taskId: '', workEndTime: null, type: '' })}
            />
            <CancelTaskModal
                taskId={currentTask.taskId && currentTask.type === 'cancel' ? currentTask.taskId : ''}
                onCancel={cancel => {
                    if (cancel) {
                        link(-1);
                        sessionStorage.setItem('getTasks', 'getTasks');
                    }
                    setCurrentTask({ taskId: '', workEndTime: null, type: '' });
                }}
            />
        </div>
    );
};
export default TaskDetails;
const FindingTasker = memo(({ task }: { task: any }) => {
    const padZreo = (num: number) => {
        return num < 10 ? `0${num}` : num.toString();
    };
    const [duration, setDuration] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const findingInterval = setInterval(() => {
            const time = task?.findTaskerRecordInfo?.startTimeOfTimer;
            if (!time) return;
            const now = dayjs();
            setDuration({
                hours: now.diff(time, 'hours'),
                minutes: now.diff(time, 'minutes') % 60,
                seconds: now.diff(time, 'seconds') % 60,
            });
        }, 1000);
        return () => clearInterval(findingInterval);
    }, []);

    const durationStr = useMemo(
        () => `${padZreo(duration.hours)}:${padZreo(duration.minutes)}:${padZreo(duration.seconds)}`,
        [duration]
    );

    return (
        <div
            className="flex-center"
            style={{
                width: 60,
                height: 60,
                borderRadius: 100,
                border: `1px solid rgba(5,37,136,0.1)`,
                marginRight: 16,
                fontFamily: 'SemiBold',
                fontWeight: 600,
                fontSize: 11,
                color: '#1A1E1F',
            }}
        >
            {durationStr}
        </div>
    );
});
